const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/HomeView.vue') // lambda because the component's create() is async
    },
    {
        path: '/archive',
        name: 'archiveview',
        component: () => import('@/views/ArchiveView.vue') // lambda because the component's create() is async
    },
    {
        path: '/addaddress/:attendeeId',
        name: 'addaddressview',
        component: () => import('@/views/AddOrEditAddress.vue') // lambda because the component's create() is async
    },
    {
        path: '/credit/:eventId',
        name: 'creditview',
        meta: { expandEventNav: true },
        component: () => import('@/views/CreditView.vue') // lambda because the component's create() is async
    },
    {
        path: '/credittypes',
        name: 'mycredittypesview',
        component: () => import('@/views/MyCreditTypes.vue') // lambda because the component's create() is async
    },
    {
        path: '/disclosures/:eventId',
        name: 'disclosuresview',
        meta: { expandEventNav: true },
        component: () => import('@/views/DisclosuresView.vue') // lambda because the component's create() is async
    },
    {
        path: '/facilitatorguide/:eventId',
        name: 'facilitatorguideview',
        meta: { expandEventNav: true },
        component: () => import('@/views/FacilitatorGuideView.vue') // lambda because the component's create() is async
    },
    {
        path: '/editaddress/:addressId',
        name: 'editaddressview',
        component: () => import('@/views/AddOrEditAddress.vue') // lambda because the component's create() is async
    },
    {
        path: '/educationalrole',
        name: 'roleview',
        component: () => import('@/views/RoleView.vue') // lambda because the component's create() is async
    },
    {
        path: '/eventexhibitors/:eventId',
        name: 'eventexhibitorsview',
        meta: { expandEventNav: true },
        component: () => import('@/views/EventExternalEntitiesView.vue') // lambda because the component's create() is async
    },
    {
        path: '/eventmaterials/:eventId',
        name: 'eventmaterialsview',
        meta: { expandEventNav: true },
        component: () => import('@/views/EventMaterialsView.vue') // lambda because the component's create() is async
    },
    {
        path: '/eventpartners/:eventId',
        name: 'eventpartnersview',
        meta: { expandEventNav: true },
        component: () => import('@/views/EventExternalEntitiesView.vue') // lambda because the component's create() is async
    },
    {
        path: '/eventsponsors/:eventId',
        name: 'eventsponsorsview',
        meta: { expandEventNav: true },
        component: () => import('@/views/EventExternalEntitiesView.vue') // lambda because the component's create() is async
    },
    {
        path: '/eventvenues/:eventId',
        name: 'eventvenuesview',
        meta: { expandEventNav: true },
        component: () => import('@/views/EventVenuesView.vue') // lambda because the component's create() is async
    },
    {
        path: '/externalentity/:externalEntityId',
        name: 'externalentityview',
        component: () => import('@/views/ExternalEntityView.vue') // lambda because the component's create() is async
    },
    {
        path: '/externalentitygraphic/:externalEntityId',
        name: 'externalentitygraphicview',
        component: () => import('@/views/ExternalEntityGraphicView.vue') // lambda because the component's create() is async
    },
    {
        path: '/material/:sessionId',
        name: 'materialview',
        meta: { expandEventNav: true },
        component: () => import('@/views/MaterialView.vue') // lambda because the component's create() is async
    },
    {
        path: '/myinterests',
        name: 'myinterestsview',
        component: () => import('@/views/MyInterestsView.vue') // lambda because the component's create() is async
    },
    {
        path: '/myschedule/:eventId/:presentationMaterial?',
        name: 'myscheduleview',
        meta: { expandEventNav: true },
        component: () => import('@/views/MyScheduleView.vue') // lambda because the component's create() is async
    },
    {
        path: '/notfound',
        name: 'notfoundview',
        component: () => import('@/views/NotFoundView.vue')
    },
    {
        path: '/payment/:eventId',
        name: 'paymentview',
        meta: { expandEventNav: true },
        component: () => import('@/views/PaymentView.vue') // lambda because the component's create() is async
    },
    {
        path: '/presenter/:presenterId',
        name: 'presenterview',
        meta: { expandEventNav: true },
        component: () => import('@/views/PresenterView.vue') // lambda because the component's create() is async
    },
    {
        path: '/presenters/:eventId',
        name: 'presentersview',
        meta: { expandEventNav: true },
        component: () => import('@/views/PresentersView.vue') // lambda because the component's create() is async
    },
    {
        path: '/personalinfo',
        name: 'personalinfoview',
        component: () => import('@/views/PersonalInfoView.vue') // lambda because the component's create() is async
    },
    {
        path: '/presenterinfo',
        name: 'presenterinfoview',
        component: () => import('@/views/PresenterInfoView.vue') // lambda because the component's create() is async
    },
    {
        path: '/profile',
        name: 'myprofileview',
        component: () => import('@/views/MyProfileView.vue') // lambda because the component's create() is async
    },
    {
        path: '/profilephoto/:attendeeId',
        name: 'profilephotoview',
        component: () => import('@/views/ProfilePhotoView.vue') // lambda because the component's create() is async
    },
    {
        path: '/register/:eventId',
        name: 'registerview',
        meta: { expandEventNav: true },
        component: () => import('@/views/RegisterView.vue') // lambda because the component's create() is async
    },
    {
        path: '/registration/:eventId',
        name: 'registrationview',
        meta: { expandEventNav: true },
        component: () => import('@/views/RegistrationView.vue') // lambda because the component's create() is async
    },
    {
        path: '/schedule/:eventId',
        name: 'scheduleview',
        meta: { expandEventNav: true },
        component: () => import('@/views/ScheduleView.vue') // lambda because the component's create() is async
    },
    {
        path: '/welcome/:eventId',
        name: 'welcomeview',
        meta: { expandEventNav: true },
        component: () => import('@/views/WelcomeView.vue') // lambda because the component's create() is async
    },
    {
        path: '/poster/:eventId',
        name: 'posterview',
        meta: { expandEventNav: true },
        component: () => import('@/views/PosterView.vue') // lambda because the component's create() is async
    },
    {
        path: '/apierror',
        name: 'ApiErrorView',
        component: () => import('@/views/ApiErrorView.vue') // lambda because the component's create() is async
    },
    {
        path: '/require-signin',
        name: 'requiresignin',
        component: () => import('@/views/RequireSignInView.vue')
    },
    {
        path: '/:pathMatch(.*)*', // This is the catch-all route
        name: 'NotFound',
        component: () => import('@/views/RequireSignInView.vue') ,
    },
    {
        path: '/transcript',
        name: 'transcript',
        component: () => import('@/views/TranscriptView.vue') // lambda because the component's create() is async
    },
    {
        path: '/unregister/:eventId',
        name: 'unregisterview',
        meta: { expandEventNav: true },
        component: () => import('@/views/UnregisterView.vue') // lambda because the component's create() is async
    },
    /*{
        path: '/test',
        name: 'testview',
        component: () => import('@/views/TestView.vue') // lambda because the component's create() is async
    },*/
]

export default routes